<template>
  <div class="money">
       <div class="moneys">
          <div class="mon01">当前余额(元)</div>
          <div class="mon02" v-if="userinfo">{{userinfo.blance || "0.00"}}</div>
          <el-button type="success" style="margin: 0 auto;width: 150px;margin-top: 20px;" @click="lijitixian">立即提现</el-button>
       </div>
       <el-tabs v-model="activeName" type="card" @tab-click="handleClick" style="margin-top: 50px;">
           <el-tab-pane label="入账明细" name="1">
             <el-table
               :data="list"
               style="width: 100%;margin-top:10px;" v-loading="loading">
               <el-table-column
                  prop="code"
                  label="消费用户" align="center">
                </el-table-column>
               <el-table-column
                  prop="price"
                  label="入账金额" align="center">
                </el-table-column>
                <el-table-column
                   prop="create_time"
                   label="入账时间" align="center">
                 </el-table-column>
                 <el-table-column
                    prop="remark"
                    label="入账说明" align="center">
                  </el-table-column>
            </el-table>
           </el-tab-pane>
           <el-tab-pane label="提现明细" name="second">
             <el-table
                :data="list"
                style="width: 100%;margin-top:10px;" v-loading="loading">
                <el-table-column
                   prop="price"
                   label="提现金额" align="center">
                 </el-table-column>
                 <el-table-column
                    label="提现方式" align="center">
                    <template slot-scope="scope">
                      {{
                        scope.row.type==1?'微信':"支付宝"
                      }}
                    </template>
                  </el-table-column>
                 <el-table-column
                    prop="create_time"
                    label="提现时间" align="center">
                  </el-table-column>
                  <el-table-column
                     prop="remark"
                     label="提现备注" align="center">
                   </el-table-column>
             </el-table>
           </el-tab-pane>
           <el-tab-pane label="消费明细" name="third">
             <el-table
               :data="list"
               style="width: 100%;margin-top:10px;" v-loading="loading">
               <el-table-column
                  prop="price"
                  label="消费金额" align="center">
                </el-table-column>
                <el-table-column
                   label="消费方式" align="center">
                   <template slot-scope="scope">
                     {{
                       scope.row.pay_type==1?'微信':"支付宝"
                     }}
                   </template>
                 </el-table-column>
                <el-table-column
                   prop="create_time"
                   label="消费时间" align="center">
                 </el-table-column>
                 <el-table-column
                    label="消费说明" align="center">
                    VIP会员购卡
                  </el-table-column>
            </el-table>
           </el-tab-pane>
        </el-tabs>
        <div style="width: 100%;margin-top: 20px;display: flex;align-items: center;justify-content: flex-end;">
          <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="[20]"
                :page-size="limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
        </div>

        <el-dialog
          title="提现"
          :visible.sync="form.dialog"
          width="30%">
          <el-form inline label-width="100px">
            <el-form-item label="提现金额:">
              <div style="display: flex;">
                 <el-input placeholder="请输入提现金额" v-model="form.price"></el-input>
                 <el-button type="primary" style="margin-left: 10px;" @click="form.price=userinfo.blance">全部</el-button>
              </div>
            </el-form-item>
            <el-form-item label="提现方式:">
               <el-radio-group v-model="form.type">
                  <el-radio :label="1">微信</el-radio>
                  <el-radio :label="2">支付宝</el-radio>
                </el-radio-group>
            </el-form-item>
            <br/>
            <el-form-item label="支付宝账号:" v-if="form.type==2">
               <el-input placeholder="请输入支付宝账号" v-model="form.identity"></el-input>
            </el-form-item>
            <el-form-item label="支付宝姓名:" v-if="form.type==2">
               <el-input placeholder="请输入支付宝姓名" v-model="form.name"></el-input>
            </el-form-item>
            <div style="width: 100%;display: flex;align-items: center;justify-content: center;margin-top: 50px;">
              <el-button type="success" style="width: 200px;" @click="tixian">立即提现</el-button>
            </div>
          </el-form>
       </el-dialog>
       <wxloginVue ref="loginData" />
  </div>
</template>

<script>
  import {mapGetters} from "vuex"
  import { ruzhangList,zhichuRecord,Withdraw_index,withdraw_deposit,wxTixian } from "@/api/gw/user"
  import wxloginVue from "@/components/wxlogin.vue"
  export default {
    computed:{
      ...mapGetters(["userinfo"]),
    },
    components:{
      wxloginVue
    },
    data(){
      return{
         activeName:"1",//1入账明细  2提现明细  3支出明细
         loading:false,
         total:0,
         list:[],
         page:1,
         limit:20,

         form:{
           dialog:false,
           price:"",//提现金额
           type:1,//1微信 2支付宝
           identity:"",//支付宝账号
           name:"",//支付宝姓名
         },
      }
    },
    watch:{
     activeName(){
       this.page = 1
       this.getList();
     },
    },
    mounted(){
      this.$store.dispatch("getUserInfo");
      this.getList();
    },
    methods:{
      //立即提现
      lijitixian(){
        //先判断有没有绑定openid
        if(!this.userinfo.openid){
          this.$refs.loginData.show();
          return;
        }
        this.form.dialog = true
      },
      reset(){
        this.form.price = ""
        this.form.identity = ""
        this.form.name = ""
      },
      getList(){
        if(this.activeName==1){
          this.ruzhangList();
        }
        if(this.activeName=="second"){
          this.Withdraw_index();
        }
        if(this.activeName=="third"){
          this.zhichuRecord();
        }
      },
      //提现
      tixian(){
        if(!this.form.price){
          this.$message.error("请输入提现金额");
          return;
        }
        if(this.form.price>this.userinfo.blance){
          this.$message.error("余额不足");
          return;
        }
        if(this.form.price>2000){
          this.$message.error("单次最多提现2000元");
          return;
        }
        //支付宝支付
        if(this.form.type==2){
          if(!this.form.identity){
            this.$message.error("请输入支付宝账号");
            return;
          }
          if(!this.form.name){
            this.$message.error("请输入支付宝姓名");
            return;
          }
          const loading = this.$loading({
            lock: true,
            text: '提现中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          withdraw_deposit({
            price:this.form.price,
            type:2,
            identity:this.form.identity,
            name:this.form.name
          }).then(()=>{
            this.$message.success("提现成功");
            this.$store.dispatch("getUserInfo");
            this.reset();
            if(this.activeName=="second"){
              this.Withdraw_index();
            }
          }).finally(()=>{
            loading.close();
          })
        }
        if(this.form.type==1){
          const loading = this.$loading({
            lock: true,
            text: '提现中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          wxTixian({
            price:this.form.price,
          }).then(()=>{
            this.$message.success("提现成功");
            this.$store.dispatch("getUserInfo");
            this.reset();
            if(this.activeName=="second"){
              this.Withdraw_index();
            }
          }).finally(()=>{
            loading.close();
          })
          
        }
      },
      //提现明细
      Withdraw_index(){
        this.loading=  true
        Withdraw_index({
          page:this.page,
          limit:this.limit
        }).then(res=>{
          console.log("提现明细",res.data);
          this.total = res.data.total
          this.list = res.data.data
        }).finally(()=>{
          this.loading =  false
        })
      },
      //入账明细
      ruzhangList(){
        this.loading=  true
        ruzhangList({
          page:this.page,
          limit:this.limit
        }).then(res=>{
          console.log("入账明细",res.data);
          this.total = res.data.total
          this.list = res.data.data
        }).finally(()=>{
          this.loading =  false
        })
      },
      //消费明细
      zhichuRecord(){
        this.loading=  true
        zhichuRecord({
          page:this.page,
          limit:this.limit
        }).then(res=>{
          console.log("消费明细",res.data);
          this.total = res.data.total
          this.list = res.data.data
        }).finally(()=>{
          this.loading =  false
        })
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.limit = val
        this.getList()
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.page = val
        this.getList()
      },
      handleClick(e){

      },
    },
  }
</script>

<style lang="scss" scoped>
  .mon02{
    width: 100%;
    text-align: center;
    font-size: 36px;
    margin-top: 10px;
    font-weight: bold;
  }
  .mon01{
    width: 100%;
    text-align: center;
    font-size: 20px;
  }
  .moneys{
     width: 100%;
     display: flex;
     align-items: center;
     justify-content: center;
     flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/views/home/components/money.vue